module.exports = __webpack_public_path__ + "static/Group 6827-ba2c4e16e996c04635dfc84f8acd19a0.png";